import styled from 'styled-components'

export interface Props {
  isValueInOptions: boolean
}

export const SelectStyled = styled.select<Props>`
  outline-color: ${({ theme }) => theme.inputActiveBorderColour};
  appearance: none; /* Remove default arrow */
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 10px 30px 10px 10px; /* Adjust right padding for space for arrow */
  border: 1px solid ${({ theme }) => theme.inputBorderColour};
  background-color: white;
  padding-right: 41px;

  background-image: linear-gradient(
      to right,
      ${({ theme }) => theme.inputBorderColour} 1px,
      transparent 1px
    ),
    /* vertical line */
      url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='%2338363D' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' d='M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.25a.75.75 0 01-1.06 0L5.25 8.27a.75.75 0 01-.02-1.06z' clip-rule='evenodd'/%3E%3C/svg%3E");
  background-repeat: no-repeat, no-repeat;
  background-position: calc(100% - 40px) center, calc(100% - 6px) center;
  background-size: 1px 100%, 28px 28px;

  border: 1px solid ${({ theme }) => theme.inputBorderColour};
  border-radius: ${({ theme }) => theme.formControlBorderRadius};
  padding: 0 41px 0 ${({ theme }) => theme.formControlHorizontalPadding};
  color: ${({ isValueInOptions, theme }) =>
    isValueInOptions ? theme.primaryTextColour : theme.secondaryTextColour};
  font-size: ${(props) => props.theme.generalFontSize};
  height: 50px;
  width: 100%;
  font-family: ${(props) => props.theme.inputFontFamily};
  font-style: ${(props) => props.theme.fontStyle};
  font-weight: ${(props) => props.theme.fontWeight};

  @media (min-width: 768px) {
    height: 60px;
  }

  :hover:not(:disabled),
  :where(.hover):not(:disabled) {
    outline: 2px solid ${({ theme }) => theme.inputHoverOutlineColour};
  }

  :active:not(:disabled),
  :where(.active):not(:disabled) {
    border-color: ${({ theme }) => theme.inputActiveBorderColour};
  }
  :focus:not(:disabled),
  :where(.focus):not(:disabled) {
    outline-offset: 0px;
    outline: 2px solid ${({ theme }) => theme.inputFocusOutlineColour};
    border-color: ${({ theme }) => theme.inputFocusBorderColour};
  }
  :active:focus,
  :where(.focus.active):not(:disabled) {
    outline: 1px solid ${({ theme }) => theme.inputActiveFocusOutlineColour};
  }

  &.placeholder,
  option[value=''] {
    color: ${(props) => props.theme.secondaryTextColour};
  }

  option:not([value='']) {
    color: ${(props) => props.theme.primaryTextColour};
  }
`

export const SelectStyledNoLine = styled(SelectStyled)`
  background-image: linear-gradient(
      to right,
      ${({ theme }) => theme.inputBorderColour} 0px,
      transparent 0px
    ),
    /* vertical line */
      url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='%2338363D' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' d='M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.25a.75.75 0 01-1.06 0L5.25 8.27a.75.75 0 01-.02-1.06z' clip-rule='evenodd'/%3E%3C/svg%3E");
  background-size: 1px 100%, 14px 14px;
`
